<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Fleet Master</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Providers
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Providers <span><i class="ic-car"></i></span>
                  </h2>
                  <p>Manage all your suppliers and partners.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Provider or Representative Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-accordion table-p15">
            <table class="table table-hover table-striped table-sticky">
              <thead>
                <tr>
                  <th>
                    Name
                    <span class="button-sort" @click="onClickSort('name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Phone
                    <span class="button-sort" @click="onClickSort('phone')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    City
                    <span class="button-sort" @click="onClickSort('city')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>Region Format</th>
                  <th class="text-left">Source</th>
                  <th class="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td class="pos-rel">
                    {{ printPhone(item) }}
                    <div class="row-big-menu">
                      <ul>
                        <li v-if="!item.isOwnInventory">
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="viewItem(item)"
                          >
                            <span>View</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToUpdate">
                          <button
                            class="btn btn-default --blue"
                            type="button"
                            @click="updateItem(item)"
                          >
                            <span>Edit</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToDelete">
                          <button
                            class="btn btn-default sts-danger"
                            type="button"
                            @click.prevent="
                              openDeleteModal('provider', item.id)
                            "
                          >
                            <span>Delete</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToUpdate">
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="viewDocument(item)"
                          >
                            <span>Document</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>{{ item.city }}</td>
                  <td>{{ item.regionFormat.title }}</td>
                  <td class="text-left">{{ item.source }}</td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!item.isOwnInventory || !isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="providermodal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Provider</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#provider-company"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">Company</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'contact' ? 'active' : '']">
                      <a
                        href="#provider-contact-person"
                        data-toggle="tab"
                        @click="activeTab = 'contact'"
                      >
                        <span>Contact Person</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'payment' ? 'active' : '']">
                      <a
                        href="#provider-payment"
                        data-toggle="tab"
                        @click="activeTab = 'payment'"
                      >
                        <span>Payment</span>
                      </a>
                    </li>
                  </ul>
                  <div
                    class="summary-error"
                    v-if="$v.model.$error || $v.location.$error"
                  >
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="provider-company"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div v-if="imageData && !isViewOnly">
                              <cropper
                                class="cropper-box"
                                :src="imagePreview"
                                ref="cropper"
                              />
                            </div>
                            <div
                              class="logo-provider"
                              v-if="!imageData && imagePreview"
                            >
                              <img
                                :src="imagePreview"
                                style="height: 225px"
                                alt
                              />
                            </div>
                            <div class="btn-upload-wrapper" v-if="!isViewOnly">
                              <button class="btn btn-upload">
                                <i class="ic-up"></i>
                                {{
                                  model.imageUri
                                    ? "Change picture"
                                    : "Upload picture"
                                }}
                              </button>
                              <input
                                id="image-uploader"
                                type="file"
                                name="image"
                                accept="image/jpeg,image/png"
                                v-on:change="onChangeImage($event.target.files)"
                              />
                              <button
                                v-if="imageData"
                                class="btn btn-default btn-block text-center"
                                @click="resetImage()"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Company Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.name.$error,
                                }"
                                v-model="model.name"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div v-if="isSubmitted && $v.model.name.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.required"
                                  >Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.maxLength"
                                  >Name must be less than
                                  {{ $v.model.name.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Company Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.email.$error,
                                }"
                                v-model="model.email"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div v-if="isSubmitted && $v.model.email.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.required"
                                  >Email is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.email"
                                  >Email is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.maxLength"
                                  >Email must be less than
                                  {{ $v.model.email.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Alternate Company Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.alternateEmail.$error,
                                }"
                                v-model="model.alternateEmail"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div
                                v-if="
                                  isSubmitted && $v.model.alternateEmail.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.alternateEmail.email"
                                  >Alternate Email is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.alternateEmail.maxLength"
                                  >Alternate Email must be less than
                                  {{
                                    $v.model.alternateEmail.$params.maxLength
                                      .max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label class="required">Company Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneCode.$error,
                                    }"
                                    placeholder=""
                                    label="label"
                                    v-model="model.phoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                    :disabled="isViewOnly"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.phoneCode.required
                                    "
                                    >Phone Code is required</small
                                  >
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneNumber.$error,
                                    }"
                                    v-model="sanitizePhoneNumber"
                                    autocomplete="off"
                                    :disabled="isViewOnly"
                                  />
                                  <div
                                    v-if="
                                      isSubmitted && $v.model.phoneNumber.$error
                                    "
                                  >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="!$v.model.phoneNumber.required"
                                      >Phone Number is required</small
                                    >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="!$v.model.phoneNumber.maxLength"
                                      >Phone Number must be less than
                                      {{
                                        $v.model.phoneNumber.$params.maxLength
                                          .max
                                      }}
                                      characters</small
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label>Alternate Company Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    placeholder=""
                                    label="label"
                                    v-model="model.alternatePhoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                    :disabled="isViewOnly"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.alternatePhoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="sanitizeAltPhoneNumber"
                                    :disabled="isViewOnly"
                                  />
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.alternatePhoneNumber.maxLength
                                    "
                                    >Alt. Phone Number must be less than
                                    {{
                                      $v.model.alternatePhoneNumber.$params
                                        .maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required"> Operating Cities </label>
                              <multiselect
                                v-model="model.operatingCities"
                                placeholder="Select city"
                                track-by="id"
                                label="name"
                                :options="selection.operatingCities"
                                :close-on-select="false"
                                :multiple="true"
                                :limit="3"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.operatingCities.$error,
                                }"
                              >
                                <span slot="noResult" class="sts-danger"
                                  >Sorry, no matching options.</span
                                >
                              </multiselect>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.operatingCities.required
                                "
                              >
                                Operating cities is required
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">
                                Currency, Decimal &amp; Time Format
                              </label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.regionFormatId.$error,
                                }"
                                placeholder=""
                                label="label"
                                v-model="model.regionFormatId"
                                :options="regionFormats"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                                :disabled="isViewOnly"
                              >
                              </v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.regionFormatId.required
                                "
                                >Region Format is required</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  :value="model.isSoleProprietor"
                                  v-model="model.isSoleProprietor"
                                />
                                <span class="pl-5 v-align-middle">
                                  Is Sole Proprietor / Independent Operator
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  :value="model.isMasterOperator"
                                  v-model="model.isMasterOperator"
                                />
                                <span class="pl-5 v-align-middle">
                                  Is Master Operator
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Temporary hide -->
                        <!-- <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <ul class="aggreement-wrapper">
                                <li class="list-terms-conditions">
                                  <div class="version-badge">
                                    V{{ termsConditions.version }}
                                  </div>

                                  <div class="description-list-tnc-wrapper">
                                    <div class="author-tnc --green">
                                      Agreement
                                    </div>
                                    <div class="author-tnc">
                                      Driver not yet accepted agreement
                                    </div>
                                    <span class="date-time-tnc"
                                      >Accepted Date:
                                      {{
                                        momentDate(termsConditions.deadlineDate)
                                      }}</span
                                    >
                                  </div>
                                  <div class="action-draft-history">
                                    <button
                                      type="button"
                                      class="btn-preview"
                                      @click="onPreview()"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 1024 1024"
                                      >
                                        <path
                                          d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z"
                                          fill="currentColor"
                                        ></path>
                                      </svg>
                                    </button>
                                    <input
                                      type="checkbox"
                                      class="control-checkbox"
                                    />
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div> -->
                        <div class="row" v-if="!model.isMasterOperator">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Master Operator</label>
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="text"
                                v-model="model.masterOperatorId"
                                :options="selection.masterOperators"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                                :disabled="isViewOnly"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  :value="model.isSalesTaxApplicable"
                                  v-model="model.isSalesTaxApplicable"
                                />
                                <span class="pl-5 v-align-middle">
                                  VAT/Sales Tax Applicable
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="model.isSalesTaxApplicable">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required"
                                >VAT/Sales Tax Number</label
                              >
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.salesTaxNumber.$error,
                                }"
                                v-model="model.salesTaxNumber"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div
                                v-if="
                                  isSubmitted && $v.model.salesTaxNumber.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.salesTaxNumber.required"
                                  >Sales Tax No. is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.salesTaxNumber.maxLength"
                                  >Sales Tax No. must be less than
                                  {{
                                    $v.model.salesTaxNumber.$params.maxLength
                                      .max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Company City</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.city.$error,
                                }"
                                v-model="model.city"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div v-if="isSubmitted && $v.model.city.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.city.required"
                                  >City is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.city.maxLength"
                                  >City must be less than
                                  {{ $v.model.city.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Company Address</label>
                              <textarea
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.location.address.$error,
                                }"
                                rows="4"
                                v-model="location.address"
                                autocomplete="off"
                              ></textarea>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.location.address.required
                                "
                                >Address is required</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <button
                              type="button"
                              id="btn-map"
                              class="btn btn-default"
                              @click.prevent="openMapModal()"
                            >
                              <i class="ic-map"></i>
                              Select Location by Map
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="provider-contact-person"
                        class="tab-pane fade"
                        :class="[activeTab === 'contact' ? 'in active' : '']"
                      >
                        <div
                          v-for="(person, personIndex) in model.contactPeople"
                          :key="personIndex"
                        >
                          <h4>Contact Person</h4>
                          <div class="form-group">
                            <label class="required">Select Title</label>
                            <div
                              class="btn-group btn-group-toggle"
                              data-toggle="buttons"
                            >
                              <label
                                v-for="(item, titleIndex) in titles"
                                :key="titleIndex"
                                :class="{
                                  active: person.title === item.value,
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.contactPeople.$each[personIndex]
                                      .title.$error,
                                }"
                                class="btn"
                                @click="person.title = item.value"
                              >
                                <input
                                  type="radio"
                                  autocomplete="off"
                                  :value="item.value"
                                  :checked="person.title === item.value"
                                  v-model="person.title"
                                />
                                {{ item.text }}
                              </label>
                            </div>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.model.contactPeople.$each[personIndex].title
                                  .required
                              "
                              >Title is required</small
                            >
                          </div>
                          <div
                            class="form-group"
                            v-if="person.title === 'Other'"
                          >
                            <label class="">Title</label>
                            <input
                              type="text"
                              class="form-control alphabets-only"
                              v-model="person.otherTitle"
                              autocomplete="off"
                            />
                          </div>
                          <div class="form-group">
                            <label class="required">Full Name</label>
                            <input
                              type="text"
                              class="form-control alphabets-characters-only"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.contactPeople.$each[personIndex]
                                    .fullName.$error,
                              }"
                              v-model="person.fullName"
                              autocomplete="off"
                              :disabled="isViewOnly"
                            />
                            <div
                              v-if="
                                isSubmitted &&
                                $v.model.contactPeople.$each[personIndex]
                                  .fullName.$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .fullName.required
                                "
                                >Full Name is required</small
                              >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .fullName.maxLength
                                "
                                >Full Name must be less than
                                {{
                                  $v.model.contactPeople.$each[personIndex]
                                    .fullName.$params.maxLength.max
                                }}
                                characters</small
                              >
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="required">Email</label>
                            <input
                              class="form-control"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.contactPeople.$each[personIndex]
                                    .email.$error,
                              }"
                              type="text"
                              v-model="person.email"
                              autocomplete="off"
                              :disabled="isViewOnly"
                              placeholder="e.g youremail@gmail.com"
                            />
                            <div
                              v-if="
                                isSubmitted &&
                                $v.model.contactPeople.$each[personIndex].email
                                  .$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .email.required
                                "
                                >Email is required</small
                              >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .email.email
                                "
                                >Email is invalid</small
                              >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .email.maxLength
                                "
                                >Email must be less than
                                {{
                                  $v.model.contactPeople.$each[personIndex]
                                    .email.$params.maxLength.max
                                }}
                                characters</small
                              >
                            </div>
                          </div>
                          <div class="form-group">
                            <label>Alternate Email</label>
                            <input
                              class="form-control"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.contactPeople.$each[personIndex]
                                    .alternateEmail.$error,
                              }"
                              type="text"
                              v-model="person.alternateEmail"
                              autocomplete="off"
                              :disabled="isViewOnly"
                              placeholder="e.g youremail@gmail.com"
                            />
                            <div
                              v-if="
                                isSubmitted &&
                                $v.model.contactPeople.$each[personIndex]
                                  .alternateEmail.$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.model.contactPeople.$each[personIndex]
                                    .alternateEmail.email
                                "
                                >Email is invalid</small
                              >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.contactPeople.$each[personIndex]
                                    .alternateEmail.maxLength
                                "
                                >Alt. Email must be less than
                                {{
                                  $v.model.contactPeople.$each[personIndex]
                                    .alternateEmail.$params.maxLength.max
                                }}
                                characters</small
                              >
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label class="required">Phone</label>
                              <div class="row">
                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <v-select
                                      class="v-search-select"
                                      :class="{
                                        'field-error':
                                          isSubmitted &&
                                          $v.model.contactPeople.$each[
                                            personIndex
                                          ].phoneCode.$error,
                                      }"
                                      placeholder=""
                                      label="label"
                                      v-model="person.phoneCode"
                                      :options="phoneCodes"
                                      :filter="searchPhoneCode"
                                      :clearable="true"
                                      :searchable="true"
                                      :filterable="true"
                                      :reduce="(option) => option.dial"
                                      :disabled="isViewOnly"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        <div class="phone-wrapper">
                                          <div
                                            class="phone-icon"
                                            :class="option.icon"
                                          ></div>
                                          <div class="phone-text">
                                            {{ option.country }}
                                          </div>
                                        </div>
                                      </template>
                                    </v-select>
                                    <small
                                      class="form-text sts-danger"
                                      v-if="
                                        isSubmitted &&
                                        !$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneCode.required
                                      "
                                      >Phone Code is required</small
                                    >
                                  </div>
                                </div>
                                <div class="col-sm-7">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control numbers-only"
                                      :class="{
                                        'field-error':
                                          isSubmitted &&
                                          $v.model.contactPeople.$each[
                                            personIndex
                                          ].phoneNumber.$error,
                                      }"
                                      autocomplete="off"
                                      v-model="person.phoneNumber"
                                      :disabled="isViewOnly"
                                    />
                                    <div
                                      v-if="
                                        isSubmitted &&
                                        $v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneNumber.$error
                                      "
                                    >
                                      <small
                                        class="form-text sts-danger"
                                        v-if="
                                          !$v.model.contactPeople.$each[
                                            personIndex
                                          ].phoneNumber.required
                                        "
                                        >Phone Number is required</small
                                      >
                                      <small
                                        class="form-text sts-danger"
                                        v-if="
                                          !$v.model.contactPeople.$each[
                                            personIndex
                                          ].phoneNumber.maxLength
                                        "
                                        >Phone Number must be less than
                                        {{
                                          $v.model.contactPeople.$each[
                                            personIndex
                                          ].phoneNumber.$params.maxLength.max
                                        }}
                                        characters</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Alternate Phone</label>
                              <div class="row">
                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <v-select
                                      class="v-search-select"
                                      placeholder=""
                                      label="label"
                                      v-model="person.alternatePhoneCode"
                                      :options="phoneCodes"
                                      :filter="searchPhoneCode"
                                      :clearable="false"
                                      :searchable="true"
                                      :filterable="true"
                                      :reduce="(option) => option.dial"
                                      :disabled="isViewOnly"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        <div class="phone-wrapper">
                                          <div
                                            class="phone-icon"
                                            :class="option.icon"
                                          ></div>
                                          <div class="phone-text">
                                            {{ option.country }}
                                          </div>
                                        </div>
                                      </template>
                                    </v-select>
                                  </div>
                                </div>
                                <div class="col-sm-7">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control numbers-only"
                                      :class="{
                                        'field-error':
                                          isSubmitted &&
                                          $v.model.contactPeople.$each[
                                            personIndex
                                          ].alternatePhoneNumber.$error,
                                      }"
                                      autocomplete="off"
                                      v-model="person.alternatePhoneNumber"
                                      :disabled="isViewOnly"
                                    />
                                    <small
                                      class="form-text sts-danger"
                                      v-if="
                                        !$v.model.contactPeople.$each[
                                          personIndex
                                        ].alternatePhoneNumber.maxLength
                                      "
                                      >Alt. Phone Number must be less than
                                      {{
                                        $v.model.contactPeople.$each[
                                          personIndex
                                        ].alternatePhoneNumber.$params.maxLength
                                          .max
                                      }}
                                      characters</small
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>Job Title</label>
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.model.contactPeople.$each[personIndex]
                                    .jobTitle.$error,
                              }"
                              v-model="person.jobTitle"
                              autocomplete="off"
                              :disabled="isViewOnly"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.model.contactPeople.$each[personIndex]
                                  .jobTitle.maxLength
                              "
                              >Job Title must be less than
                              {{
                                $v.model.contactPeople.$each[personIndex]
                                  .jobTitle.$params.maxLength.max
                              }}
                              characters</small
                            >
                          </div>
                          <div class="form-group">
                            <button
                              v-if="
                                model.contactPeople &&
                                model.contactPeople.length > 0
                              "
                              type="button"
                              class="btn btn-default sts-danger"
                              @click.prevent="removeContactPerson(personIndex)"
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <button
                              v-if="
                                model.contactPeople &&
                                model.contactPeople.length < 4
                              "
                              type="button"
                              class="btn btn-default"
                              @click.prevent="addContactPerson()"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="provider-payment"
                        class="tab-pane fade"
                        :class="[activeTab === 'payment' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="radio"
                                  class="control-radio"
                                  name="paymentMethod"
                                  value="Unspecified"
                                  v-model="model.paymentMethod"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  None
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="radio"
                                  class="control-radio"
                                  name="paymentMethod"
                                  value="BankTransfer"
                                  v-model="model.paymentMethod"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Bank Transfer
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div v-if="model.paymentMethod === 'BankTransfer'">
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required"
                                  >Account Holder Name</label
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.bankConfiguration.accountOwner
                                        .$error,
                                  }"
                                  v-model="model.bankConfiguration.accountOwner"
                                  autocomplete="off"
                                  :disabled="isViewOnly"
                                />
                                <div
                                  v-if="
                                    isSubmitted &&
                                    $v.model.bankConfiguration.accountOwner
                                      .$error
                                  "
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.bankConfiguration.accountOwner
                                        .required
                                    "
                                    >Account Owner is required</small
                                  >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.bankConfiguration.accountOwner
                                        .maxLength
                                    "
                                    >Account Owner must be less than
                                    {{
                                      $v.model.bankConfiguration.accountOwner
                                        .$params.maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Account Number</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.bankConfiguration.accountNumber
                                        .$error,
                                  }"
                                  v-model="
                                    model.bankConfiguration.accountNumber
                                  "
                                  autocomplete="off"
                                  :disabled="isViewOnly"
                                />
                                <div
                                  v-if="
                                    isSubmitted &&
                                    $v.model.bankConfiguration.accountNumber
                                      .$error
                                  "
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.bankConfiguration.accountNumber
                                        .required
                                    "
                                    >Account Number is required</small
                                  >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.bankConfiguration.accountNumber
                                        .maxLength
                                    "
                                    >Account Number must be less than
                                    {{
                                      $v.model.bankConfiguration.accountNumber
                                        .$params.maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required"
                                  >Bank Name/SWIFT Code</label
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.bankConfiguration.swift.$error,
                                  }"
                                  v-model="model.bankConfiguration.swift"
                                  autocomplete="off"
                                  :disabled="isViewOnly"
                                />
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.model.bankConfiguration.swift.maxLength
                                  "
                                  >Swift must be less than
                                  {{
                                    $v.model.bankConfiguration.swift.$params
                                      .maxLength.max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>International Account Number</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.bankConfiguration
                                        .internationalAccountNumber.$error,
                                  }"
                                  v-model="
                                    model.bankConfiguration
                                      .internationalAccountNumber
                                  "
                                  autocomplete="off"
                                  :disabled="isViewOnly"
                                />
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.model.bankConfiguration
                                      .internationalAccountNumber.maxLength
                                  "
                                  >Intl. Account Number must be less than
                                  {{
                                    $v.model.bankConfiguration
                                      .internationalAccountNumber.$params
                                      .maxLength.max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="radio"
                                  class="control-radio"
                                  name="paymentMethod"
                                  value="PayPal"
                                  v-model="model.paymentMethod"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  PayPal
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          class="row"
                          v-if="model.paymentMethod === 'PayPal'"
                        >
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">PayPal Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.paypalConfiguration.email.$error,
                                }"
                                v-model="model.paypalConfiguration.email"
                                autocomplete="off"
                                :disabled="isViewOnly"
                              />
                              <div
                                v-if="
                                  isSubmitted &&
                                  $v.model.paypalConfiguration.email.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.model.paypalConfiguration.email.required
                                  "
                                  >Email is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.model.paypalConfiguration.email
                                      .maxLength
                                  "
                                  >Email must be less than
                                  {{
                                    $v.model.paypalConfiguration.email.$params
                                      .maxLength.max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            Payment will be made in your local currency.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer" v-if="!isViewOnly">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div
            class="modal-header modal-new"
            :class="{ update: isUpdate }"
            style="padding-bottom: 10px"
          >
            <div class="row">
              <div class="col-sm-10">
                <h4>Provider Location</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="gmap-wrapper">
              <div class="pac-card" id="pac-card">
                <div id="pac-container">
                  <input
                    id="pac-input"
                    type="text"
                    placeholder="Enter a location"
                  />
                </div>
              </div>
              <div id="map"></div>
              <div class="modal-footer text-center">
                <div id="gmap-custom-control" v-show="!isViewOnly">
                  <button type="button" class="btn btn-default remove-location">
                    Reset
                  </button>
                  <button type="button" class="btn btn-primary save-location">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="deleteItem" @cancel="cancelDelete" />
    <providerDocumentComponent></providerDocumentComponent>

    <div class="modal fade" role="dialog" ref="previewModal">
      <div class="modal-dialog modal-md custom">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4 class="title-preview">{{ termsConditions.title }}</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    aria-label="Close"
                    @click="closePreviewModal()"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="modal-preview-wrapper">
                    <div v-html="termsConditions.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import moment from "moment";
import {
  required,
  requiredIf,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import providerDocumentComponent from "@/components/master/provider/ProviderDocument";
import providerService from "@/services/master/provider/providerService.js";
import regionFormatService from "@/services/master/regionFormatService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";
import termsConditionService from "@/services/master/termsCondition/termsConditionService.js";
import { operatingCityService } from "@/services/master/operatingCityService";
import maverickMap from "@/plugins/google/map.js";
import maverickGeocoding from "@/plugins/google/geocode.js";

export default {
  components: {
    deleteModal,
    providerDocumentComponent,
  },
  computed: {
    isAllowToRead: function () {
      return (
        this.allServices &&
        this.allServices["Provider"] &&
        this.allServices["Provider"].includes("Read")
      );
    },
    isAllowToCreate: function () {
      return (
        this.allServices &&
        this.allServices["Provider"] &&
        this.allServices["Provider"].includes("Create")
      );
    },
    isAllowToUpdate: function () {
      return (
        this.allServices &&
        this.allServices["Provider"] &&
        this.allServices["Provider"].includes("Update")
      );
    },
    isAllowToDelete: function () {
      return (
        this.allServices &&
        this.allServices["Provider"] &&
        this.allServices["Provider"].includes("Delete")
      );
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRuleSalesTaxNo: function () {
      return this.model.isSalesTaxApplicable
        ? { required, maxLength: maxLength(100) }
        : { maxLength: maxLength(100) };
    },
    validationRuleBankConfig: function () {
      return this.model.paymentMethod === "BankTransfer"
        ? {
            accountOwner: { required, maxLength: maxLength(150) },
            accountNumber: { required, maxLength: maxLength(100) },
            internationalAccountNumber: { maxLength: maxLength(100) },
            swift: { maxLength: maxLength(100) },
          }
        : {
            accountOwner: { maxLength: maxLength(150) },
            accountNumber: { maxLength: maxLength(100) },
            internationalAccountNumber: { maxLength: maxLength(100) },
            swift: { maxLength: maxLength(100) },
          };
    },
    validationRulePayPalConfig: function () {
      return this.model.paymentMethod === "PayPal"
        ? { email: { required, email, maxLength: maxLength(100) } }
        : { email: { email, maxLength: maxLength(100) } };
    },
    validationRuleContactPeople: function () {
      return this.model.contactPeople && this.model.contactPeople.length > 0
        ? {
            $each: {
              title: { required },
              otherTitle: {},
              fullName: { required, maxLength: maxLength(150) },
              email: { email, required, maxLength: maxLength(100) },
              alternateEmail: { email, maxLength: maxLength(100) },
              phoneCode: { required },
              phoneNumber: { required, maxLength: maxLength(20) },
              alternatePhoneNumber: { maxLength: maxLength(20) },
              jobTitle: { maxLength: maxLength(50) },
            },
          }
        : {
            $each: {
              title: {},
              otherTitle: {},
              fullName: { maxLength: maxLength(150) },
              email: { email, maxLength: maxLength(100) },
              alternateEmail: { email, maxLength: maxLength(100) },
              phoneCode: {},
              phoneNumber: { maxLength: maxLength(20) },
              alternatePhoneNumber: { maxLength: maxLength(20) },
              jobTitle: { maxLength: maxLength(50) },
            },
          };
    },
    sanitizePhoneNumber: {
      get() {
        return this.model.phoneNumber;
      },
      set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      },
    },
    sanitizeAltPhoneNumber: {
      get() {
        return this.model.alternatePhoneNumber;
      },
      set(value) {
        this.model.alternatePhoneNumber = value.replace(/\D/g, "");
      },
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      rentalLabel: null,
      airportLabel: null,
      airportAlgorithm: null,
      allServices: null,
      map: null,
      geocoder: null,
      isViewOnly: false,
      deleteId: null,
      deleteOption: null,
      imagePreview: null,
      imageData: null,
      termsConditions: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null,
      },
      items: [],
      titles: [],
      phoneCodes: [],
      regionFormats: [],
      operatingCities: [],
      selection: {
        operatingCities: [],
        masterOperators: [],
      },
      model: {},
      defaultValueAgreement: true,
      location: { name: null, address: null, latitude: null, longitude: null },
      isLoading: false,
      isUpdate: false,
      userType: null,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        name: { required, maxLength: maxLength(100) },
        email: { required, email, maxLength: maxLength(150) },
        alternateEmail: { email, maxLength: maxLength(150) },
        city: { required, maxLength: maxLength(100) },
        phoneCode: { required },
        phoneNumber: { required, maxLength: maxLength(20) },
        alternatePhoneNumber: { maxLength: maxLength(20) },
        regionFormatId: { required },
        salesTaxNumber: this.validationRuleSalesTaxNo,
        bankConfiguration: this.validationRuleBankConfig,
        paypalConfiguration: this.validationRulePayPalConfig,
        contactPeople: this.validationRuleContactPeople,
        operatingCities: { required },
      },
      location: { address: { required } },
    };
  },
  async created() {
    this.$helper.scrollTop();
    this.publicSettings = await this.$store.dispatch("setting/getAllPublic");
    // this.getTermsAndConditions();
    this.table.pageSize = this.$helper.extractSetting(
      this.publicSettings,
      "PageSize",
      25
    );
    this.rentalLabel = this.$helper.extractSetting(
      this.publicSettings,
      "RentalLabel",
      "Hourly"
    );
    this.airportLabel = this.$helper.extractSetting(
      this.publicSettings,
      "AirportLabel",
      "Airport"
    );
    this.airportAlgorithm = this.$helper.extractSetting(
      this.publicSettings,
      "AirportAlgorithm",
      "Distance"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    this.userType = profile.userType;

    this.allServices = profile.services;

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getPhoneCodes();
      await this.getRegionFormats();
      await this.fetchOperatingCities();
    }
    this.titles = [
      { value: "Mr", text: "Mr" },
      { value: "Mrs", text: "Mrs" },
      { value: "Ms", text: "Ms" },
      { value: "Other", text: "Others" },
    ];
  },
  mounted() {
    $(this.$refs.providermodal).on("hidden.bs.modal", this.closeModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);

    if (!this.map) {
      const defaultLatLng = this.$helper.extractSetting(
        this.publicSettings,
        "DefaultLatLng",
        "-6.17003832454938|106.81490242481232"
      );
      const latLng = defaultLatLng.split("|");
      const lat = parseFloat(latLng[0]);
      const lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange,
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new maverickGeocoding();
    }
  },
  updated() {
    // subscribe event
    this.$eventBus.$on("openProviderDeleteModal", this.openDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("provider-link");
    this.$helper.alphabetsOnly();
    this.$helper.alphabetsCharactersOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy() {
    // unsubscribe event
    this.$eventBus.$off("openProviderDeleteModal");
    document
      .querySelectorAll(".pac-container")
      .forEach((element) => element.remove());
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    async getTermsAndConditions() {
      try {
        const response = await termsConditionService.getAll();

        if (response.isSuccess) {
          this.termsConditions = response.data.latest;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    onPreview() {
      $(this.$refs.previewModal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closePreviewModal() {
      $(this.$refs.previewModal).modal("hide");
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    async confirmLocation(coordinate) {
      // get place from geocoding
      if (this.isMarkerChange) {
        const response = await this.geocoder.geocode(coordinate);
        if (response) {
          this.location.address = response.address;
          this.location.name = response.name;
          this.location.latitude = response.latitude;
          this.location.longitude = response.longitude;
        }
      }
      this.$notification.success("Location saved.", { title: "Success" });
      this.closeMapModal();
    },
    removeLocation() {
      document.getElementById("pac-input").value = "";
      this.isMarkerChange = false;
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null,
      };
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange(latLng) {
      this.isMarkerChange = true;
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await providerService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getRegionFormats() {
      this.regionFormats = await regionFormatService.getAll();

      for (let i = 0; i < this.regionFormats.length; i++) {
        const regionFormat = this.regionFormats[i];
        const timezone =
          regionFormat.timeZone > 0
            ? `+${regionFormat.timeZone}`
            : regionFormat.timeZone;
        regionFormat.label = `${regionFormat.title} / ${regionFormat.cultureCode} / UTC ${timezone}`;
      }
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();

      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `${item.iata} (+${item.dial})`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async fetchOperatingCities() {
      const response = await operatingCityService.getAllAsync(null, true);
      this.operatingCities = response.isSuccess ? response.data : [];
    },
    async fetchMasterOperators() {
      this.selection.masterOperators = [];
      const response = await providerService.getMasterOperators(
        this.startLoader,
        this.stopLoader
      );

      if (response.isSuccess) {
        this.selection.masterOperators = Object.entries(response.data).map(
          ([key, value]) => ({
            value: key,
            text: value,
          })
        );
      }
    },
    resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null,
      };
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.location.$reset();
    },
    searchPhoneCode(options, search) {
      const pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter((item) => {
        return (
          pattern.test(item.area) ||
          pattern.test(item.country) ||
          pattern.test(item.dial) ||
          pattern.test(item.iata)
        );
      });
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);

      if (
        this.isUpdate &&
        this.model.operatingCities &&
        this.model.operatingCities.length > 0
      ) {
        const operatingCityCountryCodes = this.model.operatingCities.map(
          (item) => {
            return item.twoDigitCountryCode;
          }
        );

        if (this.userType !== "TenantUser") {
          this.selection.operatingCities = Object.assign(
            [],
            this.operatingCities.filter((item) => {
              return (
                operatingCityCountryCodes.includes(item.twoDigitCountryCode) ||
                operatingCityCountryCodes.includes(item.threeDigitCountryCode)
              );
            })
          );
        } else {
          this.selection.operatingCities = Object.assign(
            [],
            this.operatingCities
          );
        }
      } else {
        this.selection.operatingCities = Object.assign(
          [],
          this.operatingCities
        );
      }

      if (this.model.location) {
        this.location = this.model.location;
      }

      this.fetchMasterOperators().then(() => {
        $(this.$refs.providermodal).modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    },
    closeModal() {
      const imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.providermodal).modal("hide");
    },
    openMapModal(object) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (
        this.location &&
        this.location.latitude !== null &&
        this.location.longitude !== null
      ) {
        this.map.showMarker(
          new google.maps.LatLng(
            this.location.latitude,
            this.location.longitude
          )
        );
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.providermodal).css("overflow-y", "auto");
    },
    createItem() {
      const uploader = document.getElementById("image-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isViewOnly = false;
      this.isUpdate = false;
      this.activeTab = "general";
      this.openModal({
        paymentMethod: "Unspecified",
        bankConfiguration: {},
        paypalConfiguration: {},
        contactPeople: [],
        phoneNumber: "",
        alternatePhoneNumber: "",
      });
    },
    updateItem(item) {
      this.isViewOnly = false;
      this.isUpdate = true;
      this.imagePreview = item.imageUri;
      this.activeTab = "general";
      const dataModel = {
        ...item,
        contactPeople: item.contactPeople.map((person) => ({
          ...person,
          title: this.findTitle(person.title, "title"),
          otherTitle: this.findTitle(person.title, "otherTitle"),
        })),
      };
      this.openModal(dataModel);
    },
    findTitle(value, type) {
      const findTitle = this.titles.find((val) => val.value === value);

      if (type === "title") return findTitle ? value : "Other";
      else return findTitle ? null : value;
    },
    resetImage() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.imagePreview = item.imageUri;
      this.openModal(item);
    },
    constuctPayload() {
      const payload = Object.assign({}, this.model);

      payload.contactPeople = payload.contactPeople.map((person) => ({
        ...person,
        title: person.title === "Other" ? person.otherTitle : person.title,
      }));

      payload.operatingCities = this.model.operatingCities.map(function (item) {
        return item.id;
      });

      payload.location.latitude = payload.location.latitude
        ? payload.location.latitude
        : 0;
      payload.location.longitude = payload.location.longitude
        ? payload.location.longitude
        : 0;

      return payload;
    },
    async submit() {
      this.isSubmitted = true;
      this.model.email = this.model.email ? this.model.email.toLowerCase() : "";
      this.model.alternateEmail = this.model.alternateEmail
        ? this.model.alternateEmail.toLowerCase()
        : "";
      this.$v.model.$touch();
      this.$v.location.$touch();
      if (this.$v.model.$error || this.$v.location.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.isChangeStatus = false;
        this.model.location = this.location;

        const payload = this.constuctPayload();

        if (this.isUpdate) {
          await providerService.update(payload);
          await this.uploadImage(payload.id);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          const response = await providerService.create(payload);
          await this.uploadImage(response.data);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.resetModel();
        this.closeModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async uploadImage(id) {
      const uploader = document.getElementById("image-uploader");
      if (uploader.value && uploader.value !== "") {
        const { canvas } = this.$refs.cropper.getResult();
        if (canvas) {
          const model = {
            id: id,
          };
          const formData = new FormData();
          for (const key in model) {
            if (model.hasOwnProperty(key)) {
              formData.append(key, model[key]);
            }
          }
          const blob = await new Promise((resolve) => canvas.toBlob(resolve));
          formData.append("file", blob, this.imageData.name);
          await providerService.uploadImage(formData);
        }
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.isChangeStatus = true;

        const payload = Object.assign({}, item);

        payload.operatingCities = item.operatingCities.map(function (item) {
          return item.id;
        });

        await providerService.update(payload);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
        this.resetValidations();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onChangeImage(files) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = "";
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert(
          `File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`
        );
        return;
      }
      if (
        !["jpeg", "jpg", "png"].includes(
          files[0].name
            .substring(files[0].name.lastIndexOf(".") + 1)
            .toLowerCase()
        )
      ) {
        this.imagePreview = "";
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    cancelDelete() {
      switch (this.deleteOption) {
        case "providerDocument":
          // publish message
          this.$eventBus.$emit("openModalProviderDocument", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    async deleteItem() {
      try {
        this.isLoading = true;
        switch (this.deleteOption) {
          case "provider":
            try {
              await providerService.delete(this.deleteId);
              this.$notification.success("Successfully deleted.", {
                title: "Success",
              });
              await this.getAll();
            } catch (error) {
              if (error.errors) {
                for (let index = 0; index < error.errors.length; index++) {
                  this.$notification.error(error.errors[index], {
                    title: "Error",
                  });
                }
              }
            }
            break;
          case "providerDocument":
            // publish message
            this.$eventBus.$emit("deleteProviderDocument", this.deleteId);
            break;
        }
        this.deleteId = null;
        this.deleteOption = null;
        $("#deletemodal").modal("hide");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewDocument(item) {
      // publish message
      this.$eventBus.$emit("initializeProviderDocument", item);
    },
    addContactPerson() {
      this.model.contactPeople.push({
        title: "Mr",
        otherTitle: null,
        fullName: null,
        email: null,
        phoneCode: null,
        phoneNumber: null,
      });
    },
    removeContactPerson(index) {
      this.model.contactPeople.splice(index, 1);
    },
    printPhone(item) {
      return item.phoneCode &&
        item.phoneNumber &&
        item.phoneCode.length > 0 &&
        item.phoneNumber.length > 0
        ? `(+${item.phoneCode}) ${item.phoneNumber}`
        : "";
    },
    momentDate(time) {
      return moment(time).parseZone().format("D MMMM YYYY hh:mm:ss");
    },
  },
};
</script>
<style scoped>
ul li .action-draft-history {
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

ul.aggreement-wrapper li span {
  color: #808080;
  font-size: 13px;
  font-weight: 400;
}

ul li .action-draft-history button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 3px;
  border: none;
  border-radius: 3px;
  width: 30px;
}

ul li .action-draft-history button:hover {
  background: #edf6ec;
}

ul li .action-draft-history button svg {
  color: #363636;
  width: 17px;
}

.list-terms-conditions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 5px;
  overflow: hidden;
  border: 0.5px dotted #4fb848;
  border-radius: 5px;
}

ul li.list-terms-conditions:not(:first-child) {
  margin-top: 15px;
}

ul li.list-terms-conditions.active-list-item {
  border-bottom: none;
  border-radius: 5px;
  border: 1px dotted #4fb848;
  background: #4fb848;
}

ul li.list-terms-conditions.active-list-item .author-tnc,
ul li.list-terms-conditions.active-list-item .date-time-tnc {
  color: #edf6ec;
}

ul li.list-terms-conditions.active-list-item button {
  border: 1px dotted #edf6ec;
}

ul li.list-terms-conditions.active-list-item button svg {
  color: #edf6ec;
}

ul li.list-terms-conditions.active-list-item button:hover svg {
  color: #4fb848;
}

.list-terms-conditions .version-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 45px;
  border-radius: 5px;
  background: #edf6ec;
  color: #4fb848;
  font-weight: 800;
  font-size: 20px;
}

.description-list-tnc-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 85%;
}

.description-list-tnc-wrapper .author-tnc {
  font-size: 12px;
  font-weight: 600;
}

.description-list-tnc-wrapper .date-time-tnc {
  font-size: 11px;
  color: #808080;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/master/provider/Provider.vue